module.exports = __webpack_public_path__ + "19761bc4c22826db7bd50bd213a16aaf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/water-hair.png
// module id = 2959
// module chunks = 0